/* WhichOSMap embed: loads the OS map finder and connects its buttons to our shop.
   The embed hands us an ISBN; every map's SKU in the shop is its ISBN, so we look the product up by SKU. */
(() => {
  const t = window.theme;
  const root = document.querySelector('[data-which-os-map]');
  if (!root || !t) return;

  const config = JSON.parse(root.dataset.config || '{}');
  const strings = JSON.parse(root.dataset.strings || '{}');
  const status = root.querySelector('[data-map-status]');
  const mount = root.querySelector('[data-map-mount]');
  const shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const cache = new Map();

  const say = (message, isError) => {
    status.textContent = message || '';
    status.classList.toggle('is-error', Boolean(isError));
  };

  // ISBN to product and variant: search finds the product by SKU, then we read its variants to be sure.
  const find = async (isbn) => {
    if (cache.has(isbn)) return cache.get(isbn);
    let found = null;
    try {
      const params = new URLSearchParams({
        q: isbn,
        'resources[type]': 'product',
        'resources[limit]': '5',
        'resources[options][fields]': 'variants.sku,variants.barcode'
      });
      const res = await fetch(`${t.routes.predictiveSearch}.json?${params}`, { headers: { Accept: 'application/json' } });
      if (res.ok) {
        const data = await res.json();
        const products = (data.resources && data.resources.results && data.resources.results.products) || [];
        for (const product of products) {
          const detail = await (await fetch(`${shopRoot}products/${product.handle}.js`)).json();
          const variant = detail.variants.find((v) => v.sku === isbn || v.barcode === isbn);
          if (variant) {
            found = { url: `${shopRoot}products/${product.handle}`, variantId: variant.id, available: variant.available };
            break;
          }
        }
      }
    } catch {
      found = null;
    }
    // Only remember a hit: a map that was missing a minute ago may have been published since.
    if (found) cache.set(isbn, found);
    return found;
  };

  const addToCart = async (isbn) => {
    say('');
    const product = await find(isbn);
    if (!product) return say(strings.notFound, true);
    if (!product.available) return say(strings.soldOut, true);
    try {
      // The same request the theme's own add-to-basket forms make.
      const body = new FormData();
      body.append('id', product.variantId);
      body.append('quantity', '1');
      const res = await fetch(t.routes.cartAdd, { method: 'POST', headers: { Accept: 'application/json' }, body });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || strings.error);
      if (t.cart) await t.cart.refresh();
      say(strings.added);
      const drawer = document.getElementById('CartDrawer');
      if (t.cartType === 'drawer' && drawer && t.openDialog) t.openDialog(drawer, root);
    } catch (err) {
      say(err.message || strings.error, true);
    }
  };

  const openProduct = async (isbn) => {
    say('');
    const product = await find(isbn);
    if (!product) return say(strings.notFound, true);
    window.location.href = product.url;
  };

  if (!config.key) {
    say(strings.unconfigured, true);
    return;
  }

  // The embed announces itself with this event once its script has loaded.
  document.addEventListener('os-map-init', () => {
    mount.removeAttribute('aria-busy');
    say('');
    const options = {
      centerCoordinates: config.centre || 'england',
      twoFingerNavigation: true,
      onAddToCart: addToCart,
      onOpenProductPage: openProduct,
      text: { addToCart: strings.addLabel, viewProductPage: strings.viewLabel }
    };
    if (Array.isArray(config.series) && config.series.length) options.defaultSeries = config.series;
    new window.OSMap(mount, options);
  });

  const script = document.createElement('script');
  script.src = `https://whichosmap.co.uk/js/embed.js?key=${encodeURIComponent(config.key)}`;
  script.async = true;
  script.onerror = () => say(strings.error, true);
  document.head.appendChild(script);
})();
